import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useHRStore = create(
  persist(
    (set, get) => ({
      // Employees
      employees: [
        { id: 1, name: 'John Smith', email: 'john.smith@company.com', department: 'Engineering', role: 'Senior Engineer', salary: 125000, status: 'Active', hireDate: '2022-01-15', phone: '555-0101', address: '123 Main St', performanceRating: 4.5, manager: 'Alice Johnson', leaveBalance: 15 },
        { id: 2, name: 'Sarah Johnson', email: 'sarah.j@company.com', department: 'Sales', role: 'Sales Manager', salary: 95000, status: 'Active', hireDate: '2021-06-20', phone: '555-0102', address: '456 Oak Ave', performanceRating: 4.2, manager: 'Bob Wilson', leaveBalance: 12 },
        { id: 3, name: 'Mike Chen', email: 'mchen@company.com', department: 'Marketing', role: 'Marketing Lead', salary: 85000, status: 'Active', hireDate: '2020-03-10', phone: '555-0103', address: '789 Pine Rd', performanceRating: 3.9, manager: 'Carol Davis', leaveBalance: 10 },
        { id: 4, name: 'Alice Johnson', email: 'alice.j@company.com', department: 'Engineering', role: 'Engineering Manager', salary: 135000, status: 'Active', hireDate: '2019-11-05', phone: '555-0104', address: '321 Elm St', performanceRating: 4.7, manager: 'CEO', leaveBalance: 18 },
        { id: 5, name: 'Bob Wilson', email: 'bob.w@company.com', department: 'Operations', role: 'Operations Manager', salary: 100000, status: 'Active', hireDate: '2020-08-12', phone: '555-0105', address: '654 Maple Dr', performanceRating: 4.3, manager: 'CEO', leaveBalance: 15 },
      ],

      // Departments
      departments: [
        { id: 1, name: 'Engineering', headcount: 234, openRoles: 5, budget: 4500000 },
        { id: 2, name: 'Sales', headcount: 156, openRoles: 3, budget: 2850000 },
        { id: 3, name: 'Marketing', headcount: 89, openRoles: 2, budget: 1600000 },
        { id: 4, name: 'Operations', headcount: 128, openRoles: 4, budget: 2100000 },
        { id: 5, name: 'HR & Admin', headcount: 45, openRoles: 1, budget: 800000 },
      ],

      // Payroll Data
      payrollHistory: [
        { id: 1, date: '2026-04-28', employeeId: 1, gross: 10416.67, taxes: 2000, deductions: 300, net: 8116.67, status: 'Processed' },
        { id: 2, date: '2026-04-28', employeeId: 2, gross: 7916.67, taxes: 1500, deductions: 250, net: 6166.67, status: 'Processed' },
        { id: 3, date: '2026-04-28', employeeId: 3, gross: 7083.33, taxes: 1350, deductions: 200, net: 5533.33, status: 'Processed' },
        { id: 4, date: '2026-04-15', employeeId: 1, gross: 10416.67, taxes: 2000, deductions: 300, net: 8116.67, status: 'Processed' },
      ],

      // Leave Requests
      leaveRequests: [
        { id: 1, employeeId: 1, employeeName: 'John Smith', type: 'Vacation', startDate: '2026-05-01', endDate: '2026-05-05', days: 5, status: 'Approved', reason: 'Family vacation' },
        { id: 2, employeeId: 2, employeeName: 'Sarah Johnson', type: 'Sick Leave', startDate: '2026-04-29', endDate: '2026-04-29', days: 1, status: 'Pending', reason: 'Medical appointment' },
        { id: 3, employeeId: 3, employeeName: 'Mike Chen', type: 'Personal', startDate: '2026-05-10', endDate: '2026-05-12', days: 3, status: 'Pending', reason: 'Personal matters' },
        { id: 4, employeeId: 4, employeeName: 'Alice Johnson', type: 'Vacation', startDate: '2026-06-01', endDate: '2026-06-15', days: 15, status: 'Approved', reason: 'Summer vacation' },
      ],

      // Performance Reviews
      performanceReviews: [
        { id: 1, employeeId: 1, reviewer: 'Alice Johnson', date: '2026-04-15', rating: 4.5, feedback: 'Excellent technical skills and teamwork', goals: ['Learn new framework', 'Mentor juniors'] },
        { id: 2, employeeId: 2, reviewer: 'Bob Wilson', date: '2026-04-10', rating: 4.2, feedback: 'Strong sales performance and leadership', goals: ['Increase team revenue', 'Improve client retention'] },
        { id: 3, employeeId: 3, reviewer: 'Carol Davis', date: '2026-04-05', rating: 3.9, feedback: 'Good campaign execution and creative ideas', goals: ['Lead brand initiative', 'Enhance analytics skills'] },
      ],

      // Benefits
      benefits: [
        { id: 1, name: 'Health Insurance', type: 'Medical', description: 'Comprehensive health coverage', employees: 450, premium: 500 },
        { id: 2, name: '401(k)', type: 'Retirement', description: 'Retirement savings plan with company match', employees: 420, premium: 0 },
        { id: 3, name: 'Dental Coverage', type: 'Dental', description: 'Dental and vision coverage', employees: 440, premium: 50 },
        { id: 4, name: 'Life Insurance', type: 'Insurance', description: 'Life insurance coverage', employees: 430, premium: 25 },
      ],

      // Employee Benefits Enrollment
      employeeBenefits: [
        { employeeId: 1, benefits: ['Health Insurance', '401(k)', 'Dental Coverage', 'Life Insurance'], enrollmentDate: '2022-01-15' },
        { employeeId: 2, benefits: ['Health Insurance', '401(k)', 'Dental Coverage'], enrollmentDate: '2021-06-20' },
        { employeeId: 3, benefits: ['Health Insurance', '401(k)'], enrollmentDate: '2020-03-10' },
        { employeeId: 4, benefits: ['Health Insurance', '401(k)', 'Dental Coverage', 'Life Insurance'], enrollmentDate: '2019-11-05' },
        { employeeId: 5, benefits: ['Health Insurance', '401(k)', 'Dental Coverage', 'Life Insurance'], enrollmentDate: '2020-08-12' },
      ],

      // Attendance Records
      attendance: [
        { id: 1, employeeId: 1, date: '2026-04-28', status: 'Present', hoursWorked: 8 },
        { id: 2, employeeId: 2, date: '2026-04-28', status: 'Present', hoursWorked: 8 },
        { id: 3, employeeId: 1, date: '2026-04-27', status: 'Present', hoursWorked: 8 },
        { id: 4, employeeId: 3, date: '2026-04-28', status: 'Late', hoursWorked: 7.5 },
        { id: 5, employeeId: 2, date: '2026-04-27', status: 'Absent', hoursWorked: 0 },
      ],

      // Onboarding Tasks
      onboardingTasks: [
        { id: 1, task: 'Complete IT Setup', category: 'IT', priority: 'High' },
        { id: 2, task: 'Orientation Meeting', category: 'HR', priority: 'High' },
        { id: 3, task: 'Benefits Enrollment', category: 'HR', priority: 'Medium' },
        { id: 4, task: 'Department Introduction', category: 'Operations', priority: 'Medium' },
        { id: 5, task: 'Training Modules', category: 'Development', priority: 'Medium' },
      ],

      // EMPLOYEE OPERATIONS
      addEmployee: (empData) => {
        set((state) => ({
          employees: [
            ...state.employees,
            {
              id: Date.now(),
              ...empData,
              leaveBalance: 15,
              performanceRating: 0,
            },
          ],
        }))
      },

      updateEmployee: (empId, updates) => {
        set((state) => ({
          employees: state.employees.map((e) =>
            e.id === empId ? { ...e, ...updates } : e
          ),
        }))
      },

      deleteEmployee: (empId) => {
        set((state) => ({
          employees: state.employees.filter((e) => e.id !== empId),
          payrollHistory: state.payrollHistory.filter((p) => p.employeeId !== empId),
          leaveRequests: state.leaveRequests.filter((l) => l.employeeId !== empId),
          performanceReviews: state.performanceReviews.filter((r) => r.employeeId !== empId),
        }))
      },

      // DEPARTMENT OPERATIONS
      addDepartment: (deptData) => {
        set((state) => ({
          departments: [
            ...state.departments,
            {
              id: Date.now(),
              ...deptData,
            },
          ],
        }))
      },

      updateDepartment: (deptId, updates) => {
        set((state) => ({
          departments: state.departments.map((d) =>
            d.id === deptId ? { ...d, ...updates } : d
          ),
        }))
      },

      deleteDepartment: (deptId) => {
        set((state) => ({
          departments: state.departments.filter((d) => d.id !== deptId),
        }))
      },

      // PAYROLL OPERATIONS
      addPayroll: (payrollData) => {
        set((state) => ({
          payrollHistory: [
            ...state.payrollHistory,
            {
              id: Date.now(),
              date: new Date().toISOString().split('T')[0],
              ...payrollData,
              status: 'Pending',
            },
          ],
        }))
      },

      updatePayroll: (payrollId, updates) => {
        set((state) => ({
          payrollHistory: state.payrollHistory.map((p) =>
            p.id === payrollId ? { ...p, ...updates } : p
          ),
        }))
      },

      // LEAVE OPERATIONS
      addLeaveRequest: (leaveData) => {
        set((state) => ({
          leaveRequests: [
            ...state.leaveRequests,
            {
              id: Date.now(),
              ...leaveData,
              status: 'Pending',
            },
          ],
        }))
      },

      updateLeaveRequest: (leaveId, updates) => {
        set((state) => ({
          leaveRequests: state.leaveRequests.map((l) =>
            l.id === leaveId ? { ...l, ...updates } : l
          ),
        }))
      },

      approveLeave: (leaveId) => {
        set((state) => ({
          leaveRequests: state.leaveRequests.map((l) =>
            l.id === leaveId ? { ...l, status: 'Approved' } : l
          ),
        }))
      },

      rejectLeave: (leaveId) => {
        set((state) => ({
          leaveRequests: state.leaveRequests.map((l) =>
            l.id === leaveId ? { ...l, status: 'Rejected' } : l
          ),
        }))
      },

      // PERFORMANCE REVIEW OPERATIONS
      addPerformanceReview: (reviewData) => {
        set((state) => ({
          performanceReviews: [
            ...state.performanceReviews,
            {
              id: Date.now(),
              date: new Date().toISOString().split('T')[0],
              ...reviewData,
            },
          ],
        }))
      },

      updatePerformanceReview: (reviewId, updates) => {
        set((state) => ({
          performanceReviews: state.performanceReviews.map((r) =>
            r.id === reviewId ? { ...r, ...updates } : r
          ),
        }))
      },

      // BENEFITS OPERATIONS
      addBenefit: (benefitData) => {
        set((state) => ({
          benefits: [
            ...state.benefits,
            {
              id: Date.now(),
              ...benefitData,
            },
          ],
        }))
      },

      updateBenefit: (benefitId, updates) => {
        set((state) => ({
          benefits: state.benefits.map((b) =>
            b.id === benefitId ? { ...b, ...updates } : b
          ),
        }))
      },

      // ATTENDANCE OPERATIONS
      recordAttendance: (attendanceData) => {
        set((state) => ({
          attendance: [
            ...state.attendance,
            {
              id: Date.now(),
              ...attendanceData,
            },
          ],
        }))
      },

      // CALCULATIONS
      getTotalEmployees: () => {
        return get().employees.length
      },

      getActiveLeaves: () => {
        return get().leaveRequests.filter((l) => l.status === 'Approved').length
      },

      getDepartmentStats: (deptName) => {
        const emps = get().employees.filter((e) => e.department === deptName)
        return {
          count: emps.length,
          totalSalary: emps.reduce((sum, e) => sum + e.salary, 0),
          avgRating: emps.length > 0 ? (emps.reduce((sum, e) => sum + e.performanceRating, 0) / emps.length).toFixed(1) : 0,
        }
      },

      getEmployeeById: (empId) => {
        return get().employees.find((e) => e.id === empId)
      },

      getPayrollByMonth: (month) => {
        return get().payrollHistory.filter((p) => p.date.includes(month))
      },

      getPayrollStats: () => {
        const payrolls = get().payrollHistory
        if (payrolls.length === 0) return { totalGross: 0, totalTaxes: 0, totalNet: 0 }
        return {
          totalGross: payrolls.reduce((sum, p) => sum + p.gross, 0),
          totalTaxes: payrolls.reduce((sum, p) => sum + p.taxes, 0),
          totalNet: payrolls.reduce((sum, p) => sum + p.net, 0),
        }
      },

      getPendingLeaves: () => {
        return get().leaveRequests.filter((l) => l.status === 'Pending')
      },

      getLeaveByEmployee: (empId) => {
        return get().leaveRequests.filter((l) => l.employeeId === empId)
      },

      getPerformanceReviewsByEmployee: (empId) => {
        return get().performanceReviews.filter((r) => r.employeeId === empId)
      },

      getAveragePerformanceRating: () => {
        const emps = get().employees.filter((e) => e.performanceRating > 0)
        return emps.length > 0 ? (emps.reduce((sum, e) => sum + e.performanceRating, 0) / emps.length).toFixed(1) : 0
      },

      getAttendanceRate: () => {
        const attendance = get().attendance
        if (attendance.length === 0) return 0
        const present = attendance.filter((a) => a.status === 'Present' || a.status === 'Late').length
        return ((present / attendance.length) * 100).toFixed(1)
      },

      // RESET TO DEFAULTS
      resetAllData: () => {
        set({
          employees: [
            { id: 1, name: 'John Smith', email: 'john.smith@company.com', department: 'Engineering', role: 'Senior Engineer', salary: 125000, status: 'Active', hireDate: '2022-01-15', phone: '555-0101', address: '123 Main St', performanceRating: 4.5, manager: 'Alice Johnson', leaveBalance: 15 },
            { id: 2, name: 'Sarah Johnson', email: 'sarah.j@company.com', department: 'Sales', role: 'Sales Manager', salary: 95000, status: 'Active', hireDate: '2021-06-20', phone: '555-0102', address: '456 Oak Ave', performanceRating: 4.2, manager: 'Bob Wilson', leaveBalance: 12 },
            { id: 3, name: 'Mike Chen', email: 'mchen@company.com', department: 'Marketing', role: 'Marketing Lead', salary: 85000, status: 'Active', hireDate: '2020-03-10', phone: '555-0103', address: '789 Pine Rd', performanceRating: 3.9, manager: 'Carol Davis', leaveBalance: 10 },
            { id: 4, name: 'Alice Johnson', email: 'alice.j@company.com', department: 'Engineering', role: 'Engineering Manager', salary: 135000, status: 'Active', hireDate: '2019-11-05', phone: '555-0104', address: '321 Elm St', performanceRating: 4.7, manager: 'CEO', leaveBalance: 18 },
            { id: 5, name: 'Bob Wilson', email: 'bob.w@company.com', department: 'Operations', role: 'Operations Manager', salary: 100000, status: 'Active', hireDate: '2020-08-12', phone: '555-0105', address: '654 Maple Dr', performanceRating: 4.3, manager: 'CEO', leaveBalance: 15 },
          ],
          departments: [
            { id: 1, name: 'Engineering', headcount: 234, openRoles: 5, budget: 4500000 },
            { id: 2, name: 'Sales', headcount: 156, openRoles: 3, budget: 2850000 },
            { id: 3, name: 'Marketing', headcount: 89, openRoles: 2, budget: 1600000 },
            { id: 4, name: 'Operations', headcount: 128, openRoles: 4, budget: 2100000 },
            { id: 5, name: 'HR & Admin', headcount: 45, openRoles: 1, budget: 800000 },
          ],
        })
      },
    }),
    {
      name: 'hr-store',
      getStorage: () => localStorage,
    }
  )
)
